export default "__VITE_ASSET__CivzpCab__"